import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { Zap, Activity, Wrench } from "lucide-react";
import { useWhatsApp } from "../../context/WhatsAppContext";

const HERO_IMAGE = "https://media.base44.com/images/public/69d90a760237c1a435afefa7/d6d077c4b_generated_322534ab.png";

const slides = [
  { icon: Zap, text: "Velocidade de até 1 Gbps", sub: "Download e upload ultra rápidos" },
  { icon: Activity, text: "99,8% de estabilidade", sub: "Conexão que não cai" },
  { icon: Wrench, text: "Instalação grátuita", sub: "Contrate agora e economize" },
];

export default function HeroSection() {
  const { openWhatsAppModal } = useWhatsApp();

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">


      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 w-full pt-28 pb-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >


            <h1 className="font-poppins font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-tight mb-6">
              <span className="text-shimmer">Internet Fibra Óptica</span>
              <br />
              <span style={{ color: '#4a4a4a' }}>na Sua Região</span>
            </h1>

            <p className="text-lg text-muted-foreground max-w-lg mb-8 leading-relaxed">
              Mais velocidade, estabilidade e suporte de verdade.
              Planos com fibra óptica 100% para sua casa ou empresa.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button onClick={openWhatsAppModal} className="w-full sm:w-auto">
                <Button
                  size="lg"
                  className="bg-success hover:bg-success/90 text-white font-bold text-base px-8 py-6 glow-green w-full sm:w-auto"
                >
                  Falar no WhatsApp
                </Button>
              </button>
              <a href="#planos">
                <Button
                  size="lg"
                  variant="outline"
                  className="border-primary text-primary hover:bg-primary hover:text-white font-semibold text-base px-8 py-6 w-full sm:w-auto transition-colors"
                >
                  Ver Planos
                </Button>
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="hidden lg:block"
          >
            <div className="glass-card rounded-2xl p-8 border-glow">
              <div className="space-y-6">
                {slides.map((slide, i) => {
                  const Icon = slide.icon;
                  const isActive = true; // Sempre ativo
                  return (
                    <motion.div
                      key={i}
                      animate={{
                        opacity: 1,
                        scale: 1,
                      }}
                      transition={{ duration: 0.5 }}
                      className={`flex items-center gap-4 p-4 rounded-xl transition-all duration-500 glass-card border-glow`}
                    >
                      <div
                        className={`h-12 w-12 rounded-xl flex items-center justify-center flex-shrink-0 bg-primary`}
                      >
                        <Icon className={`h-6 w-6 text-white`} />
                      </div>
                      <div>
                        <p className="font-poppins font-semibold text-foreground">{slide.text}</p>
                        <p className="text-sm text-muted-foreground">{slide.sub}</p>
                      </div>
                    </motion.div>
                  );
                })}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}